/**
 * `PersonalRentInfo`的执行上下文的工厂，一个执行上下文代指组件被使用的场景，例如订单签约或订单续约
 * 不同的上下文隔离组件在不同场景下的特殊处理逻辑，避免大量的if-else
 * 通过Context.get(contextName, vm)获取当前场景的实例，每个实例上的方法会自动绑定vm，可正常使用this访问组件
 *
 * '''这是个临时方案，最终通过CompositionAPI或者其他方法重构组件时可能会移除
 */

/**
 * @example
 * ```
 * // 在组件中使用
 * // 获取默认上下文
 * const context = Context.get(CONTEXT_TYPE.DEFAULT, this)
 * // 调用上下文方法
 * context.clearFormData()
 * ```
 */
import { defaultContext } from './defaultContext.js'
import { orderRenewalContext } from './orderRenewalContext.js'

function bindVM(target, vm) {
  return new Proxy(target, {
    get(obj, prop) {
      if (typeof obj[prop] === 'function') {
        return obj[prop].bind(vm)
      }
      return obj[prop]
    },
  })
}

// 预定义的上下文类型
export const CONTEXT_TYPE = {
  DEFAULT: 'default',
  // 订单续约
  ORDER_RENEWAL: 'orderRenewal',
}

export default {
  get(contextName, vm) {
    let context
    switch (contextName) {
      case CONTEXT_TYPE.DEFAULT:
        context = defaultContext
        break
      case CONTEXT_TYPE.ORDER_RENEWAL:
        context = orderRenewalContext
        break
      default:
        throw new Error(`Context "${contextName}" not found`)
    }
    return bindVM(context, vm)
  },
}
